'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var projectLoadHelper = require('../helper/projectLoadHelper');
var i18n = require('../helper/i18n');

var Authorization = React.createClass({
  getInitialState: function () {
    return {
      error: ''
    };
  },
  render: function () {
    return (
      <div className="authorization">
        <h3>{i18n.get('ENTER_PASSWORD')}</h3>
        <div className="verify">
          <div className="pwd-input">
            <input ref="pwd" type="text" placeholder={i18n.get('PASSWORD')}/>
            <button onClick={this.auth}>{i18n.get('VALIDATE')}</button>
            <p className="error">{this.state.error}&nbsp;</p>
          </div>
        </div>
      </div>
    );
  },
  auth: function () {
    var pwdInput = ReactDOM.findDOMNode(this.refs.pwd);
    var pwd = pwdInput.value;
    var self = this;
    if (!pwd) {
      this.setState({
        error: i18n.get('PASSWORD_CANNOT_BE_EMPTY')
      });
      return;
    }

    this.setState({
      error: ''
    }, function () {
      projectLoadHelper.auth(pwd, function (err, res) {
        if (err) {
          self.setState({
            error: res.statusCode === 401 ? i18n.get('WRONG_PASSWORD') : err.message
          });
          return;
        }
        self.setState({
          error: i18n.get('RIGHT_PASSWORD')
        }, function () {
          setTimeout(function () {
            window.location.reload();
          }, 100);
        });
      });
    });
  }
});

module.exports = Authorization;


// WEBPACK FOOTER //
// ./src/views/Authorization.jsx